<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Gift voucher noCTA</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'ConciergeImage')"
            [blockData]="block.variables?.ConciergeImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="ConciergeImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'ConciergeImageHref')"
            [blockData]="block.variables?.ConciergeImageHref ?? ''"
            [placeholder]="hrefPlaceholder"
            variable="ConciergeImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ConciergeImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.ConciergeImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="4000"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'ConciergeImageAlt')"
            [blockData]="block.variables?.ConciergeImageAlt ?? ''"
            [placeholder]="altPlaceholder"
            variable="ConciergeImageAlt"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'ConciergeHeading')"
            [blockData]="block.variables?.ConciergeHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="ConciergeHeading"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'ConciergeText')"
            [blockData]="block.variables?.ConciergeText ?? ''"
            [placeholder]="textPlaceholder"
            variable="ConciergeText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.ConciergeImage" class="col-6">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ConciergeImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.ConciergeImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.ConciergeImageAlt)"
            /></a>
          </div>
          <div class="col-6">
            <div [innerHTML]="$safeNavigationMigration(block.variables?.ConciergeHeading)"></div>
            <div
              class="mt-3"
              [innerHTML]="$safeNavigationMigration(block.variables?.ConciergeText)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
